import { useEffect, useRef } from "react";

const portfolioItems = [
{
  image: "https://static.lumi.new/6f/6f36dc93d8050561b9a05b9c791b585c.png",
  label: "Restaurante"
},
{
  image: "https://static.lumi.new/62/62062d68a42f086492dda502dd737697.png",
  label: "Clínica"
},
{
  image: "https://static.lumi.new/74/743044a4898dc5acad313b6803c01846.png",
  label: "Salão de Beleza"
},
{
  image: "https://static.lumi.new/0e/0ed384ac07ff1fe082dc2fc3f47d2990.png",
  label: "Imobiliária"
},
{
  image: "https://static.lumi.new/e9/e932506e510ad25ac2b796e8d4353888.png",
  label: "Academia"
},
{
  image: "https://static.lumi.new/4c/4c9716848e9678ea9a3e73347921df94.png",
  label: "Loja de Roupas"
},
{
  image: "https://static.lumi.new/02/0259b1b94bd8b7aff6d74c0a92293d9a.png",
  label: "Consultoria"
},
{
  image: "https://static.lumi.new/b8/b80c1f5313399052d953d59d5b1dd634.png",
  label: "Pet Shop"
}];


export default function Galeria() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".fade-up").forEach((el) => {
              el.classList.add("visible");
            });
          }
        });
      },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="galeria" ref={sectionRef} className="md:py-14 bg-gray-50 pt-[20px] pb-[20px]">
      <div className="max-w-6xl mx-auto px-5">
        {/* Cabeçalho */}
        <div className="text-center max-w-2xl mx-auto mb-8">
          <div className="fade-up inline-flex items-center gap-2 bg-blue-50 rounded-full px-4 py-1.5 mb-5">
            <span className="text-blue-600 text-xs font-semibold tracking-wide uppercase">
              Portfólio
            </span>
          </div>
          <h2 className="fade-up fade-up-delay-1 text-3xl md:text-5xl font-bold text-gray-900 leading-tight text-balance">
            Alguns modelos de sites que criamos
          </h2>
          <p className="fade-up fade-up-delay-2 text-gray-500 text-base md:text-lg mt-4">
            Cada site é adaptado ao tipo de negócio e necessidade do cliente.
          </p>
        </div>

        {/* Grid da galeria */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {portfolioItems.map((item, i) =>
          <div
            key={item.label}
            className={`fade-up fade-up-delay-${Math.min(i % 4 + 1, 5)} group relative overflow-hidden rounded-2xl bg-white border border-gray-200 hover:border-blue-200 transition-all duration-500 hover:shadow-2xl hover:shadow-blue-100/40 hover:-translate-y-2`}>

              <div className="aspect-[4/3] overflow-hidden">
                <img
                src={item.image}
                alt={`Site para ${item.label}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy" />

              </div>
              <div className="p-4 flex items-center justify-between">
                <span className="text-sm font-semibold text-gray-800">
                  {item.label}
                </span>
                <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-1 rounded-full">
                  Site profissional
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}